export const reportStyles = `
  @page {
    size: A4;
    margin: 0;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    width: 210mm;
    height: 297mm;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.3;
    color: #333;
    background: white;
    margin: 0;
    padding: 0;
  }

 .page {
  position: relative;
  width: 210mm;
  height: fit-content;
  min-height: 297mm; 
  padding: 5mm 10mm;
  background: white;
  box-sizing: border-box;
}

.first-page {
  height: auto !important;
  min-height: 297mm;
}

.last-page {
  height: auto !important;
  min-height: 0 !important;
  page-break-after: avoid !important;
}

.page.first-page.last-page {
  height: auto !important;
  min-height: 0 !important;
  page-break-after: avoid !important;
}

.page:not(.last-page) {
   page-break-after: always;
}

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4mm;
  }

  .header-logo {
    height: 8mm;
  }

  .main-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4mm;
    padding-bottom: 2mm;
    border-bottom: 0.5mm solid #e5e7eb;
  }
  
  .main-logo {
    height: 12mm;
  }

  .report-title {
    font-weight: bold;
    color: #111827;
    margin-bottom: 20px;
  }

  .summary-section {
    margin-bottom: 10mm;
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5mm;
    margin-bottom: 8mm;
  }

  .summary-card {
    background: #f8f9fa;
    border: 0.25mm solid #e9ecef;
    border-radius: 2mm;
    padding: 5mm;
  }

  .progress-section {
    margin-top: 8mm;
    padding: 5mm;
    background: #f8f9fa;
    border: 0.25mm solid #e9ecef;
    border-radius: 2mm;
  }

  .progress-bar {
    width: 100%;
    height: 2.5mm;
    background: #e9ecef;
    border-radius: 1.25mm;
    overflow: hidden;
    margin: 3mm 0;
  }

  .progress-fill {
    height: 100%;
    background: #0066cc;
  }

  .table-container {
    margin-top: 5mm;
  margin-bottom: 0; 
  border: 0.25mm solid #e9ecef;
  border-radius: 2mm;
  overflow: hidden;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 9pt;
  }

  .table-row{
    height: 20mm !important;
  }

  .table-header {
    background: #f8f9fa;
  }

  th {
    padding: 3mm;
    text-align: left;
    font-weight: 600;
    color: #1a1a1a;
    border-bottom: 0.5mm solid #e9ecef;
    
  }

  td {
    padding: 3mm;
    border-bottom: 0.25mm solid #e9ecef;
    overflow: hidden;
  }

  tr:last-child td {
    border-bottom: none;
  }

  .course-cell {
    font-weight: 500;
    color: #1a1a1a;
  }
    
  .date-cell {
    white-space: nowrap;
    color: #666;
  }

  .grade-cell {
    text-align: center;
    font-weight: 500;
  }

  .grade-cell.has-grade {
    color: #0066cc;
  }

  @media print {
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
       margin: 0;
    padding: 0;
    }

    .page {
    page-break-after: always;
    margin: 0;
  }
  
  .last-page {
    page-break-after: avoid !important;
    height: auto !important;
  }
  }
`;
